import { fetchPayouts } from '@api';
import { queryClient } from '@basqet-dashboard/common/config';
import { generatedDates } from '@basqet-dashboard/common/utils';
import { useEffect, useState } from 'react';
import { useInfiniteQuery } from 'react-query';
import { toast } from 'react-toastify';

const useFetchPayouts = () => {
  const [payouts, setPayouts] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [status, setStatus] = useState('');
  const [dateFilter, setDateFilter] = useState({ from: '', to: '' });
  let recentPayouts = [];
  const {
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    isError,
    data,
    refetch,
    isRefetching,
    isLoading
  } = useInfiniteQuery(
    'allPayouts',
    ({ pageParam }) => {
      return fetchPayouts({ offset: pageParam, searchQuery, status, dateFilter });
    },
    {
      getNextPageParam: (lastPage) => {
        const hasNext = lastPage.meta?.hasNext;
        const lastPayout = lastPage && lastPage.data[lastPage.data.length - 1];
        return hasNext ? lastPayout && lastPayout.id : undefined;
      }
    }
  );
  if (isError) {
    toast.error('Error fetching payouts');
  }

  const filterByDate = (dateType) => {
    if (dateType) {
      setDateFilter({ from: generatedDates[dateType](), to: generatedDates.now() });
    } else {
      setDateFilter({ from: null, to: null });
    }
  };

  const reloadPayouts = () => {
    setPayouts([]);
    queryClient.removeQueries('allPayouts', { exact: true });
    refetch({ resetQueries: true });
  };

  useEffect(() => {
    if (data && data.pages) {
      let aggregatedPayouts = [];
      data.pages.map(({ data: payoutsList }) => {
        aggregatedPayouts = [...aggregatedPayouts, ...payoutsList];
      });
      setPayouts(aggregatedPayouts);
    }
  }, [data]);
  recentPayouts = payouts.slice(0, 3);

  useEffect(() => {
    reloadPayouts();
  }, [dateFilter, status]);

  useEffect(() => {
    setStatus('');
    reloadPayouts();
  }, [searchQuery]);

  return {
    recentPayouts,
    payouts,
    status,
    searchQuery,
    filterByDate,
    setStatus,
    setSearchQuery,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    isRefetching,
    isLoading
  };
};

export { useFetchPayouts };
